module.exports = __webpack_public_path__ + "static/media/Discord-Logo-White.145dc557.svg";